import { IconProp, RotateProp } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

import { Icon, TabItem } from "@atoms/index"

import { ViewBarPhaseProps } from "./ViewBarPhase.types"

const icons: Record<ObjectPhase, { icon: IconProp; iconOnActive: IconProp; rotation?: RotateProp }> = {
    active: {
        icon: faIcon({ name: "circle-minus", style: "regular" }),
        iconOnActive: faIcon({ name: "circle-minus", style: "solid" }),
        rotation: 90,
    },
    inactive: {
        icon: faIcon({ name: "ban", style: "regular" }),
        iconOnActive: faIcon({ name: "ban", style: "solid" }),
    },
    open: {
        icon: faIcon({ name: "circle-dashed", style: "regular" }),
        iconOnActive: faIcon({ name: "circle-dashed", style: "solid" }),
    },
    closed: {
        icon: faIcon({ name: "box-archive", style: "regular" }),
        iconOnActive: faIcon({ name: "box-archive", style: "solid" }),
    },
}

export default function ViewBarPhase(props: ViewBarPhaseProps) {
    const { phase, title, activePhase, onPhaseChange } = props

    const isSelected = phase === activePhase
    const { icon, iconOnActive, rotation } = icons[phase]

    return (
        <TabItem
            iconInReactNode={
                <Icon
                    icon={icon}
                    iconOnActive={iconOnActive}
                    rotation={rotation}
                    isActive={isSelected}
                    container="square"
                    size={14}
                />
            }
            isSelected={isSelected}
            onClick={() => onPhaseChange(phase)}
            noDebounce={true}
            title={title}
        />
    )
}
